import { useQuery } from "@tanstack/vue-query";

export interface TestimonialItem {
  name: string;
  text: string;
  img_local?: string;
  link?: string;
  id?: number;
}

const TESTIMONIALS_LIMIT = 3;

export function useLandingTestimonials() {
  const config = useRuntimeConfig();
  const { authFetch } = useAuthFetch();

  const { data: testimonialsRaw, suspense } = useQuery({
    queryKey: ["landing-testimonials"],
    queryFn: () =>
      authFetch<TestimonialItem[]>(
        `${config.public.baseURL}v1/testimonials/`,
        {
          params: { type: 1, length_min: 100, length_max: 150 },
        },
      ).catch(() => []),
  });

  const testimonials = computed(() => {
    const list = testimonialsRaw.value ?? [];
    return list.slice(0, TESTIMONIALS_LIMIT);
  });

  return { testimonials, suspense };
}
